import { render, staticRenderFns } from "./info-detail.vue?vue&type=template&id=308499c6&"
import script from "./info-detail.vue?vue&type=script&lang=js&"
export * from "./info-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports